import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal from '@mui/material/Modal';
import { Box, Paper } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

import Button from 'src/component/UI/Button';
import toast from 'src/utils/toast';
import './DisplayInfoModal.scss';

export default function DisplayInfoModal (props) {
  const [copiedField, setCopiedField] = useState(null);

  const handleCopy = async (text, fieldName) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(fieldName);
      toast.success(`${fieldName} copied to clipboard`);
      setTimeout(() => {
        setCopiedField(null);
      }, 2000);
    } catch (err) {
      toast.error('Failed to copy to clipboard');
    }
  };

  return (
    <Modal
      data-testid='display-info-modal'
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='display-info-modal-title'
    >
      <div className='modal display-info-modal'>
        <h2 className='display-info-modal-title'>{props.title || 'Information'}</h2>
        <p className='display-info-modal-warning'>
          Please save the password now - you won&apos;t be able to see it again!
        </p>

        <Box className='display-info-modal-content'>
          <Paper elevation={1} className='display-info-field'>
            <div className='display-info-field-label'>Email</div>
            <div className='display-info-field-value'>
              <span className='display-info-field-text'>{props.data?.email || 'N/A'}</span>
              <Button
                className='display-info-copy-button'
                onClick={() => handleCopy(props.data?.email, 'Email')}
                icon={copiedField === 'Email' ? <CheckIcon style={{ fontSize: 16 }} /> : <ContentCopyIcon style={{ fontSize: 16 }} />}
                compact
                ariaLabel='Copy email'
              />
            </div>
          </Paper>

          <Paper elevation={1} className='display-info-field'>
            <div className='display-info-field-label'>Password</div>
            <div className='display-info-field-value'>
              <span className='display-info-field-text display-info-password'>{props.data?.password || 'N/A'}</span>
              <Button
                className='display-info-copy-button'
                onClick={() => handleCopy(props.data?.password, 'Password')}
                icon={copiedField === 'Password' ? <CheckIcon style={{ fontSize: 16 }} /> : <ContentCopyIcon style={{ fontSize: 16 }} />}
                compact
                ariaLabel='Copy password'
              />
            </div>
          </Paper>
        </Box>

        <div className='button-bar'>
          <Button variant="contained" onClick={props.handleClose}>Close</Button>
        </div>
      </div>
    </Modal>
  );
}

DisplayInfoModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.object
};

DisplayInfoModal.defaultProps = {
};
